
    <p-toast />
    <div class="admin-layout" [class.admin-layout--hub]="isHub()">
      @if (!isHub()) {
        <app-sidebar
          [mobileOpen]="mobileOpen()"
          [collapsed]="sidebarCollapsed()"
          (closeMobile)="mobileOpen.set(false)"
          (toggleCollapse)="toggleSidebar()"
        />
      }

      <app-topbar
        [isHub]="isHub()"
        [sidebarCollapsed]="sidebarCollapsed()"
        (menuToggle)="onMenuToggle()"
      />

      <main
        class="layout-content"
        [class.layout-content--hub]="isHub()"
        [class.layout-content--with-sidebar]="!isHub() && hasSidebar() && !sidebarCollapsed()"
      >
        <div class="content-wrapper" @routeAnimation>
          <router-outlet />
        </div>
      </main>
    </div>

    <!-- Welcome modal: set display name -->
    <p-dialog
      [(visible)]="showDisplayNameDialog"
      [modal]="true"
      [closable]="false"
      [draggable]="false"
      [style]="{width: '460px'}"
      [showHeader]="false"
      styleClass="dn-blur-backdrop"
    >
      <div class="dn-dialog">
        <div class="dn-dialog__mascot-wrap">
          <img
            [src]="isFemale ? 'images/welcome-female.png' : 'images/welcome-male.png'"
            alt=""
            class="dn-dialog__mascot"
          />
        </div>
        <h2 class="dn-dialog__title">{{ isFemale ? 'Bienvenida' : 'Bienvenido' }}!</h2>
        <p class="dn-dialog__subtitle">Como te gustaria que te llamemos?</p>
        <div class="dn-dialog__field">
          <input
            pInputText
            [(ngModel)]="displayNameInput"
            placeholder="Ej: Carlos Gamarra"
            class="dn-dialog__input"
            [disabled]="savingDisplayName()"
            (keydown.enter)="confirmDisplayName()"
          />
        </div>
        <small class="dn-dialog__hint">Solo se muestra una vez. Puedes cambiarlo despues en tu perfil.</small>
        @if (displayNameError) {
          <small class="dn-dialog__error">{{ displayNameError }}</small>
        }
        <p-button
          label="Confirmar"
          icon="pi pi-check"
          styleClass="w-full dn-confirm-btn"
          [loading]="savingDisplayName()"
          [disabled]="!displayNameInput.trim()"
          (onClick)="confirmDisplayName()"
        />
      </div>
    </p-dialog>
